export default __webpack_public_path__ + "static/media/OTK_Logo.2c677afd.png";